import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { HashimotoTestFieldEnum } from '../types';
import TestsQuery from './TestsQuery';

type result = {
  loading: boolean;
  error: ApolloError | undefined;
  hashimotoTestHistory?: any;
};

interface ITestsConnectorApollo {
  children: (result: result) => React.ReactElement;
  variable?: HashimotoTestFieldEnum;
}

const TestsConnectorApollo: React.FC<ITestsConnectorApollo> = ({ children, variable }) => {
  const { loading, error, data } = useQuery(TestsQuery, { variables: { filter: variable } });

  const result: result = {
    loading,
    error,
  };

  if (!loading) {
    result.hashimotoTestHistory = data.hashimoto.hashimotoTestHistory.edges;
  }

  return children(result);
};

export default TestsConnectorApollo;
